import { Card } from "taltech-styleguide";
import { WidgetProps } from "./Widgets.types";
import { PropsWithChildren } from "react";
import { getProps } from "@components-system";

/**
 * Widget Component
 * 
 * Renders a styled card component with a title, subtitle, and children content.
 * 
 * @param {PropsWithChildren<WidgetProps>} propsParam - The props for the widget component.
 * @returns {JSX.Element} - The rendered widget component.
 */
export const Widget: React.FC<any> = (propsParam: PropsWithChildren<WidgetProps>) => {
  const props = getProps(propsParam);
  const { title, subTitle, id = "WIDGET_ID_NOT_SET", children } = props;
  return (
    <Card key={id} className={`w-100 ${props.className ? props.className : ""}`}>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Subtitle>{subTitle}</Card.Subtitle>
        <Card.Text className="mt-3">{children}</Card.Text>
      </Card.Body>
    </Card>
  );
};
